export const emptyString = '';

export const underscore = '_';

export const isLetter = (value: string): boolean => {
  return value.length === 1 && !!value.match(/[a-z]/i);
};

export const isDigit = (value: string): boolean => {
  return /^\d$/.test(value);
};

export const isLetterOrDigit = (value: string): boolean => {
  if (isLetter(value)) {
    return true;
  }

  if (isDigit(value)) {
    return true;
  }

  return false;
};

export const isUpper = (value: string): boolean => {
  return value === value.toUpperCase();
};

export const formatSymbols = (value: string): string => {
  var symbolReplacement = value.replace(/[^\w\s]/g, function (match,) {
    var symb = Object.keys(characters).filter(value => characters[value] === match);
    if(symb && symb.length === 1) {
      return ' ' + symb[0] + ' ';
    }
    return match;
  });

  var trimUnmanagedCharacters = symbolReplacement.replace(/\W+/g, ' ');

  return trimUnmanagedCharacters;
};

export const formatSnakeCase = (value: string): string => {
  if (!value) {
    return emptyString;
  }

  value = formatSymbols(value);

  const length = value.length > 30 ? 30 : value.length;
  let previous: string = null;
  let current: string = null;
  let next: string = value.charAt(0);

  const systemName: string[] = [];
  for (let i = 0; i < length; i++) {
    previous = current;
    current = next;
    next = i < length - 1 ? value.charAt(i + 1) : null;

    if (isDigit(current)) {
      systemName.push(current);
    } else if (isLetter(current)) {
      if (isUpper(current)) {
        if (!!previous && previous !== underscore && !!next && isLetterOrDigit(next) && !isUpper(next)) {
          systemName.push(underscore);
        }
      }
      systemName.push(current.toLowerCase());
    } else {
      if (!!next && isLetterOrDigit(next) && !!previous && previous !== underscore) {
        systemName.push(underscore);
        current = underscore;
      } else if (!!previous && previous === underscore) {
        current = underscore;
      } else {
        current = null;
      }
    }
  }

  return systemName.join('').replace('u_id', 'uid');
};

export enum characters {
  percnt = '%',
  excl = '!',
  quest = '?',
  dollar = '$',
  num = '#',
  ast = '*',
  plus = '+',
  lt = '<',
  gt = '>',
  equals = '=',
  pound = '£',
  cent = '¢',
  yen = '¥',
  euro = '€',
  plusmn = '±',
}